import React from "react";

export const useAddLog = () => {
  const [logs, setLogs] = React.useState([]);

  const handleLogs = React.useCallback((msg) => {
    setLogs((prev) => [...prev, msg].slice(0, 50));
    // console.log("💻", msg);
  }, []);
  return { handleLogs, logs, setLogs };
};
